/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListTasksQueryResponse, ListTasksPathParams, ListTasksQueryParams, ListTasks400, ListTasks401, ListTasks403, ListTasks404, ListTasks409, ListTasks500 } from "../../types/planningTasksController/ListTasks.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListTasksUrl(organizationId: ListTasksPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/tasks` as const }
  return res
}

/**
 * @summary List tasks across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/tasks}
 */
export async function listTasks(organizationId: ListTasksPathParams["organizationId"], params?: ListTasksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListTasksQueryResponse, ResponseErrorConfig<ListTasks400 | ListTasks401 | ListTasks403 | ListTasks404 | ListTasks409 | ListTasks500>, unknown>({ method : "GET", url : getListTasksUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}